import React from "react";
import ReactDOM from "react-dom/client";
import "leaflet/dist/leaflet.css";

import "./i18n";

import App from "./App";
import { registerSW } from "./serviceWorkerRegistration";

import { Provider } from "react-redux";
import { configureStore } from "./redux/store";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <Provider store={configureStore({})}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// Register service worker for PWA offline support.
// Must be called AFTER render() so React has time to mount.
registerSW({
  onSuccess: () => console.info("[AMS] App is cached and ready for offline use."),
  onUpdate:  () => console.info("[AMS] New version available — reloading…"),
});